import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Card as _Card, minWidth } from '@calm-web/design-system';

export const Card = styled(_Card)<{
	isWithinModal?: boolean;
}>`
	border-radius: 20px !important;
	border-color: ${palette('white')};
	text-align: center;

	${minWidth('desktop')} {
		padding: 48px !important;
	}
`;

export const AuthPromptToggleWrapper = styled.div`
	display: grid;
	grid-row-gap: 0.5rem;
	margin-top: 2rem;
`;

export const HeaderWrapper = styled.div`
	display: grid;
	margin-bottom: 2rem;
`;

export const SocialSignupWrapper = styled.ul`
	list-style-type: none;
	padding: 0;
`;

export const Wrapper = styled.div`
	color: ${palette('gray7')};
	text-align: center;
`;
